import { orderBy } from 'lodash';
import { ContactTarget, ContactTargetCategory } from '@/customer/models/Customer';
import { DossierId } from '@/dossier/models/AbstractDossier';
import DossierContactTarget from '@/shared/models/DossierContactTarget';
import CustomerType from '../constants/CustomerType';
import DossierContact from './DossierContact';

export default class ContactContext {
  constructor(
    readonly dossierId: DossierId,
    public contacts: Array<DossierContact> = [],
  ) {
    this.sortContacts();
  }

  setContacts(contacts: Array<DossierContact>): void {
    this.contacts = contacts;
    this.sortContacts();
  }

  mergeContact(contact: DossierContact): void {
    const existing = this.contacts.find(c => c.id === contact.id);
    if (existing) {
      // al changeable data is contained within customer
      existing.customer = contact.customer;
    } else {
      this.contacts.push(contact);
    }
    this.sortContacts();
  }

  getPrimary(): DossierContact | undefined {
    return this.contacts.find(c => c.customer.type === CustomerType.DRIVER) ?? this.contacts.find(c => c.customer.type === CustomerType.OWNER);
  }

  getPrimaryTargets(): Array<DossierContactTarget> {
    return this.wrapTargets(this.getPrimary()?.customer?.emails ?? []);
  }

  wrapTargets(targets: Array<ContactTarget>): Array<DossierContactTarget> {
    return DossierContactTarget.forAllTargetsOfContacts(targets, this.contacts);
  }

  hasLeasingContacts(): boolean {
    return this.contacts.some(contact => contact.isLeasing);
  }

  hasNonDrivers(): boolean {
    return this.contacts.some(contact => contact.customer.type !== CustomerType.DRIVER);
  }

  getTargetsByCategory(categories: Array<ContactTargetCategory>): Array<DossierContactTarget> {
    return this.contacts.flatMap(contact => categories
      .flatMap(c => contact.customer?.getContactTargetsByCategory(c) ?? [])
      .map(target => new DossierContactTarget(contact, target)));
  }

  private sortContacts(): void {
    this.contacts = orderBy(this.contacts, ['type', 'customer.fullName'], ['asc', 'asc']);
  }
}